var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-avatar',{staticClass:"Avatar",attrs:{"variant":"empty","src":_vm.getImage,"size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }